export default "__VITE_ASSET__D46LLO2F__"